import packageJson from '../../package.json';

/**
 * Expose the version of the app
 */
export const getVersion = () => packageJson.version;
